import React from "react";

interface Event {
   title: string;
  description: string;
  dateTime: string;
  action: string;
}

interface Props {
  events: Event[];
}

const CurrentEvents: React.FC<{ events: Event[] }> = ({ events }) => {
  if (events.length === 0) return <p  className="no-events">No Current events</p>;

  return (
    <div className="event-container">
      <h3 className="subtitle-text">Current Events</h3>
      <ul className="events-list">
        {events.map((event, idx) => (
          <li key={idx} className="event-card">
            <strong className="event-title colorOrange">{event.title}</strong> <br />
            <span className="event-description">{event.description}</span> <br />
            <span className="event-date"><i className="fa-solid fa-calendar-day colorOrange"></i> {event.dateTime}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default CurrentEvents;